export enum ServiceType {
  NYUSHO = 3,
  TSUSHO = 2,
  TOKUSHU = 4,
  SHOTAKI = 5,
  NOT_SUPPORT = -1
}

export enum EntityTypes {
  CORP = "CORP",
  OFFICE = "OFFICE"
}

export enum OfficeStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}

export enum PremiumType
{
    PREMIUM = 1,
    STANDARD = 0
}